import store from '@/store'

export const requestOptions = {
    get(url) {
        return {
            method: 'GET',
            ...headers(),
            url: url
        }
    },
    postData(data, url) {
        return {
            method: 'POST',
            ...headers(),
            data: data,
            url: url
        }
    },
    post(url) {
        return {
            method: 'POST',
            ...headers(),
            url: url
        }
    },
    patch(data, url) {
        return {
            method: 'PATCH',
            ...headers(),
            data: data,
            url: url
        }
    },
    put(data, url) {
        return {
            method: 'PUT',
            ...headers(),
            data: data,
            url: url
        }
    },
    delete(url) {
        return {
            method: 'DELETE',
            ...headers(),
            url: url
        }
    }
}

function headers() {
    if (store.state.oidcStore.access_token) {
        const currentToken = store.state.oidcStore.access_token
        let authHeader = {}
        authHeader = { Authorization: 'Bearer ' + currentToken }
        return {
            headers: {
                ...authHeader,
                'Content-Type': 'application/json'
            }
        }
    } else {
    return {
        'Content-Type': 'application/json'
    };
    }
}